module.exports = __webpack_public_path__ + "static/media/arrow-down-icon.0c48ac0b.webp";